<ion-row>
  <ion-col class="plan-description">
    {{message}}
  </ion-col>
</ion-row>
